<template>
  <div class="mvc_main thongke">
    <div style="text-align: center;" class="mvc_digitCounter thongke">
    <img class="mvc_digitCounterImg thongke" src="/img/thong-ke/3.gif" alt="3" title="3">
    <img class="mvc_digitCounterImg thongke" src="/img/thong-ke/5.gif" alt="5" title="5">
    <img class="mvc_digitCounterImg thongke" src="/img/thong-ke/6.gif" alt="6" title="6">
    <img class="mvc_digitCounterImg thongke" src="/img/thong-ke/8.gif" alt="8" title="8">
    <img class="mvc_digitCounterImg thongke" src="/img/thong-ke/3.gif" alt="3" title="3">
    <img class="mvc_digitCounterImg thongke" src="/img/thong-ke/8.gif" alt="8" title="8">
    </div>
    <div style="text-align: center;" class="mvc_people thongke">
        <table align="center" cellpadding="0" cellspacing="0" style="width: 95%;" class="mvc_peopleTable thongke">
        <tbody>
            <tr align="left" title="09-04-2019">
            <td><img class="mvc_peopleImg thongke" src="/img/thong-ke/vtoday.gif" alt="Hôm nay" title="Hôm nay"></td>
            <td>Hôm nay</td>
            <td align="right">39</td>
            </tr>
            <tr align="left" title="09-03-2019">
            <td><img class="mvc_peopleImg thongke" src="/img/thong-ke/vyesterday.gif" alt="Hôm qua" title="Hôm qua"></td>
            <td>Hôm qua</td>
            <td align="right">168</td>
            </tr>
            <tr align="left" title="09-02-2019 - 09-08-2019">
            <td><img class="mvc_peopleImg thongke" src="/img/thong-ke/vweek.gif" alt="Tuần này" title="Tuần này"></td>
            <td>Tuần này</td>
            <td align="right">586</td>
            </tr>
            <tr align="left" title="09-01-2019 - 09-30-2019">
            <td><img class="mvc_peopleImg thongke" src="/img/thong-ke/vmonth.gif" alt="Tháng này" title="Tháng này"></td>
            <td>Tháng này</td>
            <td align="right">1368</td>
            </tr>
            <tr align="left" title="">
            <td><img class="mvc_peopleImg thongke" src="/img/thong-ke/vall.gif" alt="Tất cả" title="Tất cả"></td>
            <td>Tất cả</td>
            <td align="right">356838</td>
            </tr>
        </tbody>
        </table>
    </div>
    </div>
</template>
<script>
export default {
  name: "RwvThongKe"
};
</script>
